export default {
  DEFAULT: "#FFFFFF",
  SELECTED_TRIP: "#edf0f5",
};
